module.exports = __webpack_public_path__ + "img/IMG_1561.b8e47de0.jpg";